import cn from 'classnames';
import * as React from 'react';

import IntrinsicElements = React.JSX.IntrinsicElements;

type Props = {
  tagName: keyof IntrinsicElements;
  inlineStyles: string;
  customClasses?: string;
  className?: string;
  children?: React.ReactNode;
};

const Layout: React.FC<Props> = ({ tagName = 'div', inlineStyles, customClasses, className, children, ...props }) => {
  const TagName = tagName as React.ElementType;

  return (
    <>
      <TagName className={cn(className, customClasses)} {...props}>
        {children}
      </TagName>
      {inlineStyles && !!inlineStyles.length && (
        <style>{`
          ${inlineStyles}
        `}</style>
      )}
    </>
  );
};

export default Layout;
